import React, { Component } from "react";
import UnitBankAccountCheckDeposits from "./unitCheckDeposits";

class BankAccountCheckDeposits extends Component {
	constructor(props) {
		super(props);
		this.state = {
			accountStatus: props.bankAccountInfo ? props.bankAccountInfo.status : undefined,
		};
	}

	render() {
		return (
			<>
				{this.props.bankAccountInfo !== undefined &&
					this.props.bankAccountInfo.source === "UN" &&
					this.props.bankAccountInfo.accountStatus !== "Closed" &&
					<UnitBankAccountCheckDeposits
						bankAccountId={this.props.bankAccountId}
						bankAccountInfo={this.props.bankAccountInfo}
						updateCheckDeposits={this.props.updateCheckDeposits}
					/>
				}
			</>
		);
	}
}

export default BankAccountCheckDeposits;
